import axios from 'axios';
import { API_URL_TRENDING } from '../constantes/constantes';

/**
 * Obtiene las tendencias recientes de UnoTV.
 *
 * @async
 * @param {AbortSignal|null} signal - Señal opcional para cancelar la petición.
 * @param {number} timeout - Tiempo máximo de espera en milisegundos.
 * @returns {Promise<{statusCode: number, data: Object|Array, aborted?: boolean}>}
 * Respuesta de la API o un objeto normalizado en caso de error.
 */
export async function postTrending(signal = null, timeout = 600000) {
  try {
    const response = await axios({
      method: 'POST',
      url: API_URL_TRENDING,
      timeout,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
      },
      data: {
        source: 'cs',
        limit: 300,
        days: 2,
        top_n: 10
      },
      ...(signal ? { signal } : {})
    });

    return {
      statusCode: response.status,
      data: response.data
    };
  } catch (error) {
    if (error.code === 'ERR_CANCELED' || error.name === 'AbortError') {
      return { statusCode: 499, data: [], aborted: true };
    }

    if (error.response) {
      return { statusCode: error.response.status, data: [] };
    }

    if (error.code === 'ECONNABORTED') {
      console.error(`[Timeout] POST:`, error.message);
    } else {
      console.error(`[Network Error] POST:`, error.message, 'Code:', error.code);
    }

    return { statusCode: 500, data: [] };
  }
}